// extracted by mini-css-extract-plugin
module.exports = {"cells":"cells_cells__HEsM6","cellsRowWrapper":"cells_cellsRowWrapper__1ruAZ","cellsRow":"cells_cellsRow__2HnQE"};